'use client';
import Image from 'next/image';
import Link from 'next/link';

const partners = [
  {
    alt: "ai-news-hub",
    src: "/images/ai-news-hub.webp",
    width: 300,
    height: 300,
    link: "https://www.ainewshub.org/",
  },

  {
    alt: "aimojo",
    src: "/images/aimojo.webp",
    width: 300,
    height: 300,
    link: "https://aimojo.io/",
  },

  {
    alt: "aicastmedia",
    src: "/images/aicastmedia-logo.webp",
    width: 300,
    height: 300,
    link: "https://aicastmedia.com/",
  },

  {
    alt: "bigdataanalyticsnews",
    src: "/images/bigdataanalyticsnews-logo.webp",
    width: 300,
    height: 300,
    link: "https://bigdataanalyticsnews.com/",
  },
    {
    alt: "aiml",
    src: "/images/aiml.webp",
    width: 300,
    height: 300,
    link: "https://aiml.events/",
  },
  {
    alt: "aiedgeinsights",
    src: "/images/ai-edgeInsights.svg",
    width: 300,
    height: 300,
    link: "http://www.aiedgeinsights.com/",
  },
  {
    alt: "gogetgpt",
    src: "/images/gogetgpt-logo.webp",
    width: 300,
    height: 300,
    link: "https://gogetgpt.com/",
  },
  {
    alt: "techedgeai",
    src: "/images/techedgeai.webp",
    width: 300,
    height: 300,
    link: "https://techedgeai.com/",
  },
  {
    alt: "aipressroom",
    src: "/images/publicity-marketplace.webp",
    width: 300,
    height: 300,
    link: "https://aipressroom.com/",
  },
  {
    alt: "Innmind-logo",
    src: "/images/Innmind-logo.webp",
    width: 300,
    height: 300,
    link: "https://innmind.com/",
  },
  {
    alt: "unite-ai",
    src: "/images/unite-ai.svg",
    width: 300,
    height: 300,
    link: "https://www.unite.ai/",
  },
  {
    alt: "bfmtimes",
    src: "/images/bfmtimes.webp",
    width: 300,
    height: 300,
    link: "https://bfmtimes.com/",
  },
  {
    alt: "huidu",
    src: "/images/huidu-dark.webp",
    width: 300,
    height: 300,
    link: "https://www.huidu.cn/en",
  },
  {
    alt: "securityafrica",
    src: "/images/securityafrica-logo.webp",
    width: 300,
    height: 300,
    link: "https://securityafricamagazine.com/",
  },
  {
    alt: "fvmglobal",
    src: "/images/fvmglobal-logo.webp",
    width: 300,
    height: 300,
    link: "https://www.fvmglobal.com/",
  },
  {
    alt: "gignomist",
    src: "/images/gignomist.webp",
    width: 300,
    height: 300,
    link: "https://gignomist.com/",
  },
  {
    alt: "expotobi",
    src: "/images/expotobi-logo.webp",
    width: 300,
    height: 300,
    link: "https://expotobi.com/",
  },
  {
    alt: "cionews",
    src: "/images/tms-news-cionews.webp",
    width: 300,
    height: 300,
    link: "https://cionews.co.in/",
  },
  {
    alt: "itedgenews",
    src: "/images/itedgenews-logo.webp",
    width: 300,
    height: 300,
    link: "https://www.itedgenews.africa/",
  },
  {
    alt: "cioreview",
    src: "/images/cioreview.webp",
    width: 300,
    height: 300,
    link: "https://www.cioreview.com/",
  },
  {
    alt: "enterpriseviewpoint",
    src: "/images/enterpriseviewpoint.webp",
    width: 300,
    height: 300,
    link: "https://enterpriseviewpoint.com/",
  },
  {
    alt: "grcoutlook",
    src: "/images/grc-outlook-logo.webp",
    width: 300,
    height: 300,
    link: "https://grcoutlook.com/",
  },
  {
    alt: "yura-agency",
    src: "/images/yura.webp",
    width: 100,
    height: 100,
    link: "https://yura.agency/",
  },
  {
    alt: "westasiawatch",
    src: "/images/cropped-west-asia-logo.webp",
    width: 300,
    height: 300,
    link: "https://westasiawatch.com/",
  },
  {
    alt: "futurum",
    src: "/images/futurum-logo.webp",
    width: 300,
    height: 300,
    link: "https://futurumevent.com/",
  },
  {
    alt: "nendigital",
    src: "/images/nendigital-logo.webp",
    width: 300,
    height: 300,
    link: "http://www.nendigital.com/",
  },
  {
    alt: "techrevolt",
    src: "/images/techrevolt.webp",
    width: 300,
    height: 300,
    link: "https://techrevolt.news/",
  },
  {
    alt: "aitoolsnetwork",
    src: "/images/atn-transparent.webp",
    width: 300,
    height: 300,
    link: "https://aitoolsnetwork.com/artificial-intelligence-events/",
  },
  {
    alt: "galliumventures",
    src: "/images/gallium-logo.webp",
    width: 300,
    height: 300,
    link: "https://galliumventures.com/",
  },
  {
    alt: "thetechnewsportal",
    src: "/images/thetechnews-logo.webp",
    width: 300,
    height: 300,
    link: "https://thetechnewsportal.com/",
  },
  {
    alt: "deeptech-times",
    src: "/images/deeptech-logo.webp",
    width: 300,
    height: 300,
    link: "https://deeptechtimes.com/",
  },
  {
    alt: "cxquest",
    src: "/images/cxquest.webp",
    width: 300,
    height: 300,
    link: "https://cxquest.com/",
  },
  {
    alt: "entarabi",
    src: "/images/entarabi.webp",
    width: 300,
    height: 300,
    link: "https://entarabi.com/en/",
  },
  {
    alt: "edarabia",
    src: "/images/edarabia-logo.webp",
    width: 300,
    height: 300,
    link: "https://www.edarabia.com/",
  },
  {
    alt: "tekafrika",
    src: "/images/tekafrika.webp",
    width: 300,
    height: 300,
    link: "https://tekafrika.tv/",
  },
  {
    alt: "cryptonite",
    src: "/images/cryptonite.webp",
    width: 300,
    height: 300,
    link: "https://www.cryptonite.ae/",
  },
  {
    alt: "challenge-magazine-economique-maroc-min",
    src: "/images/challenge-magazine-economique-maroc-min.webp",
    width: 300,
    height: 300,
    link: "https://www.challenge.ma/",
  },
  {
    alt: "zexprwire-logo",
    src: "/images/zexprwire-logo.webp",
    width: 300,
    height: 300,
    link: "https://zexprwire.com/",
  },
];

const MediaPartnerSection = () => {
  return (
    <section
      id="partners"
      className="w-full px-4 pt-[30px] pb-[60px] flex flex-col items-center justify-center bg-gradient-to-br from-[#fef6fa] to-[#f9f1f8]"
    >
      <div className="w-full max-w-[1270px]">
        {/* Section Title */}
        <h2 className="text-[24px] sm:text-[30px] lg:text-4xl font-extrabold leading-[28px] sm:leading-[34px] lg:leading-5xl text-center text-text-darkest mb-[30px]">
          Media Partners
        </h2>

        {/* Partner Logos Box */}
        <div className="w-full bg-white border-[2px] border-[#FA4B7F] rounded-[16px] p-6 sm:p-4">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6 place-items-center">
            {partners.map((partner, index) => (
             
              <Link key={index} href={partner.link} target="_blank" 
              rel={index === 0 ? "noopener noreferrer" : "noopener noreferrer nofollow"}>
              <Image
                src={partner.src}
                alt={partner.alt}
                width={partner.width}
                height={partner.height}
                unoptimized
                className="w-[200px] h-[80px] object-contain transition-transform duration-200 hover:scale-105"
              />
            </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaPartnerSection;
